import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ScanConfiguration, ScanConfigurationType } from 'src/app/models/ScanConfigurationModel';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PlatformApiService } from 'src/app/services/platform-api.service';

@Component({
  selector: 'cw-ci-scan-configuration-edit',
  templateUrl: './scan-configuration-edit.component.html',
  styleUrls: [],
})
export class ScanConfigurationEditComponent implements OnInit {
  _scanConfiguration: ScanConfiguration;
  availableScanConfigurationTypes = ScanConfigurationType;

  @Output() stateChange: EventEmitter<any> = new EventEmitter();

  @Input() set scanConfiguration(value: ScanConfiguration) {
    this._scanConfiguration = value;
    this.scanConfigurationForm.reset();
    if (this._scanConfiguration.id) {
      this.scanConfigurationForm.controls.active.setValue(this._scanConfiguration.active);
      this.scanConfigurationForm.controls.name.setValue(this._scanConfiguration.name);
      this.scanConfigurationForm.controls.definitionId.setValue(this._scanConfiguration.definitionId);
      this.scanConfigurationForm.controls.type.setValue(this._scanConfiguration.type);
      this.scanConfigurationForm.controls.s3Key.setValue(this._scanConfiguration.s3Key);
    }
  }

  scanConfigurationForm = new FormGroup ({
    active: new FormControl('', []),
    name: new FormControl('', [Validators.required]),
    definitionId: new FormControl('', [Validators.required]),
    type: new FormControl('', [Validators.required]),
    s3Key: new FormControl('', [Validators.required]),
  });

  constructor(private _platformApi: PlatformApiService) { }

  ngOnInit() {
  }

  saveScanConfiguration() {
    if (this.scanConfigurationForm.valid) {
      const saveConfig = new ScanConfiguration({
        active: this.scanConfigurationForm.value.active,
        name: this.scanConfigurationForm.value.name,
        definitionId: this.scanConfigurationForm.value.definitionId,
        type: this.scanConfigurationForm.value.type,
        s3Key: this.scanConfigurationForm.value.s3Key,
      });
      if (this._scanConfiguration.id) {
        saveConfig.id = this._scanConfiguration.id;
      }

      this._platformApi.saveScanConfiguration(saveConfig).subscribe(
        resp => {
          this.stateChange.emit({state: 'CREATESUCCESS'})
        }, err => {
          if (err.error.code == 'S3KEY_NOTFOUND') {
            this.scanConfigurationForm.controls.s3Key.setErrors({objectNotFound: true});
          }
        }
      );
    }
  }

  cancel() {
    this.scanConfigurationForm.reset();
    this.stateChange.emit({state: 'EDITCANCEL'});
  }
}
